// extracted by mini-css-extract-plugin
export default {"search":"newsbreak_search__Qp-xf","fieldList":"newsbreak_fieldList__6XCki","field":"newsbreak_field__46VBc","count":"newsbreak_count__rn+hk","list":"newsbreak_list__HY96f"};